// AMAC Suites - real property photos uploaded by owner
const ASSET_BASE =
  "https://customer-assets.emergentagent.com/job_casa-loano/artifacts";

export const IMAGES = {
  // Hero: best "wow" shot — kitchen / dining with sea-themed table setting
  hero: `${ASSET_BASE}/ymglel9q_LOANO%20MAGGIO%202026%20%285%29.jpeg`,

  // Property interiors
  kitchen: `${ASSET_BASE}/ymglel9q_LOANO%20MAGGIO%202026%20%285%29.jpeg`,
  bedroom1: `${ASSET_BASE}/vdbgzvmi_LOANO%20MAGGIO%202026%20%2815%29.jpeg`,
  bedroom2: `${ASSET_BASE}/vdbgzvmi_LOANO%20MAGGIO%202026%20%2815%29.jpeg`,
  bathroom: `${ASSET_BASE}/tg3ug5nq_LOANO%20MAGGIO%202026%20%2818%29.jpeg`,
  bathroomDetail: `${ASSET_BASE}/o6nvfe63_LOANO%20MAGGIO%202026%20%2820%29.jpeg`,
  amenities: `${ASSET_BASE}/2n6mkr5j_LOANO%20MAGGIO%202026%20%2819%29.jpeg`,

  // Highlights below description (3 photos)
  living: `${ASSET_BASE}/5glb96g6_LOANO%20MAGGIO%202026%20%2841%29.jpeg`,
  terrace: `${ASSET_BASE}/4v1sl97h_ChatGPT%20Image%2018%20mag%202026%2C%2013_46_56.png`,
  dining: `${ASSET_BASE}/vj352259_LOANO%20MAGGIO%202026%20%2833%29.jpeg`,

  // Additional gallery photos
  tableSet: `${ASSET_BASE}/h58hd886_LOANO%20MAGGIO%202026%20%287%29.jpeg`,
  tableSet2: `${ASSET_BASE}/q01h05ja_LOANO%20MAGGIO%202026%20%286%29.jpeg`,
  cabinetDishes: `${ASSET_BASE}/mn9f9keu_LOANO%20MAGGIO%202026%20%2824%29.jpeg`,
  cabinetGlasses: `${ASSET_BASE}/qm3bf5w8_LOANO%20MAGGIO%202026%20%2823%29.jpeg`,

  // Latest batch: terrace, dotazioni, electrodomestici
  terraceDay: `${ASSET_BASE}/wwy2eqhj_LOANO%20MAGGIO%202026%20%2836%29.jpeg`,
  drawerKit: `${ASSET_BASE}/g32kds1v_LOANO%20MAGGIO%202026%20%2829%29.jpeg`,
  drawerCutlery: `${ASSET_BASE}/snv8577w_LOANO%20MAGGIO%202026%20%2828%29.jpeg`,
  dishwasher: `${ASSET_BASE}/ny6spmsf_LOANO%20MAGGIO%202026%20%2827%29.jpeg`,
  appliances: `${ASSET_BASE}/dlheonqt_LOANO%20MAGGIO%202026%20%2826%29.jpeg`,

  // Bedroom & terrace additional shots
  bedroomFull: `${ASSET_BASE}/he8as50e_LOANO%20MAGGIO%202026%20%2816%29.jpeg`,
  bedroomDoor: `${ASSET_BASE}/l8n9o95i_LOANO%20MAGGIO%202026%20%2817%29.jpeg`,
  terraceChairs: `${ASSET_BASE}/6l5uleqq_LOANO%20MAGGIO%202026%20%2810%29.jpeg`,

  // Reuse the kitchen for legacy refs
  balcony: `${ASSET_BASE}/ymglel9q_LOANO%20MAGGIO%202026%20%285%29.jpeg`,

  // Loano destination shot
  beach: `${ASSET_BASE}/p2nbb246_60f56e3f1b80f-1626697279%20%281%29.jpg`,
  loanoTown:
    "https://images.unsplash.com/photo-1533929736458-ca588d08c8be?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
};
